import baseMessage from './baseMessage'

export const ES_UY = {
  message: {
    ...baseMessage,
    label: {
      dni: 'CEDULA',
      userHint: 'Se puede buscar por Nombres, Apellidos, Documento de identidad'
    }
  }
}
